export default __webpack_public_path__ + "static/media/D3.js Avanzado - Linkedin.c1725d62.png";